/**
 * Скролл к элементу по его id с учетом отступа
 * @param elementId - id элемента, к которому нужно прокрутить
 * @param offset - отступ в пикселях (по умолчанию 150)
 */

export const scrollToElement = (elementId: string, offset: number = 50) => {
  const targetElement = document.getElementById(elementId)

  if (!targetElement) return

  const elementTop = targetElement.getBoundingClientRect().top + window.scrollY

  window.scrollTo({
    top: elementTop - offset,
    behavior: 'smooth',
  })
}
